import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NoteLead } from '@core/models/interfaces/note';
import { NoteService } from '@core/services/note.service';
import { TranslateModule } from '@ngx-translate/core';
import { CustomAvatarComponent } from '@shared/components/custom-avatar/custom-avatar.component';
import { SearchInputComponent } from '@shared/components/search-input/search-input.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CheckboxModule } from 'primeng/checkbox';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayModule } from 'primeng/overlay';

@Component({
  selector: 'app-note-lead-multi-select-dropdown',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    HttpClientModule,
    InputTextModule,
    OverlayModule,
    InfiniteScrollDirective,
    IconFieldModule,
    InputIconModule,
    FloatLabelModule,
    CheckboxModule,
    CustomAvatarComponent,
    SearchInputComponent,
    TranslateModule
  ],
  templateUrl: './note-lead-multi-select-dropdown.component.html',
  styleUrl: './note-lead-multi-select-dropdown.component.scss'
})
export class NoteLeadMultiSelectDropdownComponent {
  @Input() appendTo: 'body' | HTMLElement | undefined;
  @Input({ required: true }) leadsSelected: NoteLead[] = [];
  @Input({ required: true }) totalLeads: number = 0;
  @Input({ required: true }) leads: NoteLead[] = [];
  @Input({ required: true }) label: string = '';
  @Input('leadIds') leadIds: string[] | undefined;
  @Input('policyIds') policyIds: string[] | undefined;

  @Output() leadsSelectedChange = new EventEmitter<NoteLead[]>();

  keyword = '';
  page = 0;

  visible = false;

  constructor(
    private noteService: NoteService
  ) { }

  get selectedLeadsString() {
    return this.leadsSelected.map(lead => lead.fullName).join(', ');
  }

  onScroll() {
    if (this.totalLeads > this.leads.length) {
      this.page++;
      this.fetchLeads('SCROLL');
    }
  }

  onLeadsSelectedChange() {
    this.leadsSelectedChange.emit(this.leadsSelected);
  }

  fetchLeads(type: 'SCROLL' | 'SEARCH') {
    this.noteService
      .getLeadForNotesManagement({
        page: this.page,
        searchTerm: this.keyword,
        // leadIds: this.leadIds,
        // policyIds: this.policyIds
      })
      .subscribe({
        next: res => {
          this.totalLeads = res.data.total;
          if (type === 'SCROLL') {
            this.leads = [...this.leads, ...res.data.content];
          }
          if (type === 'SEARCH') {
            this.leads = res.data.content;
          }
        }
      });
  }

  onSearch(keyword: string) {
    this.keyword = keyword;
    this.page = 0;
    this.fetchLeads('SEARCH');
  }
}
